/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: ShortText = 1, Paragraph = 2, Dropdown = 3, Checkbox = 4, Attachments = 5
 */
export enum Routemize_Constants_FieldType {
    SHORT_TEXT = 'ShortText',
    PARAGRAPH = 'Paragraph',
    DROPDOWN = 'Dropdown',
    CHECKBOX = 'Checkbox',
    ATTACHMENTS = 'Attachments',
}
